(() => {
  if (customElements.get('policy-popup')) return;

  class PolicyPopup extends HTMLElement {
    constructor() {
      super();
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.hashTrigger = this.dataset.hash || '';
      this.policyUrl = (this.dataset.policyUrl || '').replace(/\/$/, '');

      this.querySelectorAll('[data-action="close"]').forEach((el) =>
        el.addEventListener('click', this.onClose)
      );

      document.addEventListener('click', this.onTriggerClick);
      document.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.querySelectorAll('[data-action="close"]').forEach((el) =>
        el.removeEventListener('click', this.onClose)
      );
      document.removeEventListener('click', this.onTriggerClick);
      document.removeEventListener('keydown', this.onKeyDown);
    }

    isOpen() {
      return this.getAttribute('aria-hidden') === 'false';
    }

    onTriggerClick(event) {
      const link = event.target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute('href');

      if (this.hashTrigger && href === this.hashTrigger) {
        event.preventDefault();
        this.lastFocus = link;
        this.open();
        return;
      }

      if (this.policyUrl && href.includes('/policies/')) {
        const pathname = href.startsWith('http') ? new URL(href).pathname : href;
        const cleanPath = pathname.replace(/\/$/, '');
        if (cleanPath === this.policyUrl || cleanPath.endsWith(this.policyUrl)) {
          event.preventDefault();
          this.lastFocus = link;
          this.open();
        }
      }
    }

    open() {
      this.setAttribute('aria-hidden', 'false');
      // Remember the previous inline value so closing doesn't unlock scroll
      // while another overlay (e.g. the cart drawer) is still open.
      this._prevBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.querySelector('.policy-popup__close')?.focus();
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = this._prevBodyOverflow || '';
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
    }

    onClose() {
      this.close();
    }

    onKeyDown(event) {
      if (!this.isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      } else if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    }

    trapFocus(event) {
      const focusable = Array.from(
        this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.getClientRects().length > 0);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('policy-popup', PolicyPopup);
})();
